import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useHref } from "react-router-dom";

const TermsModal = ({ show, onAccept, onDecline }) => {
  const [checked, setChecked] = useState(false);
  const termsUrl = useHref("/terms-and-conditions");

  useEffect(() => {
    if (show) {
      setChecked(false); 
    }
  }, [show]); 

  return (
    <Modal show={show} centered backdrop="static" keyboard={false}>
      <Modal.Body className="p-4 rounded-3 text-start">
        <h4 className="mb-3">Terms & Conditions</h4>

        <p className="text-primary small">
          By using this application, you agree to follow the company’s policies,
          maintain confidentiality, and not misuse the platform. Please review
          the detailed Terms & Conditions before proceeding.
        </p>

        <p className="mt-3">
          Please{" "}
          <a
            href={termsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            click here
          </a>{" "}
          to read the full Terms & Conditions.
        </p>
        <Form.Check
          className="terms-checkbox d-flex align-items-center"
          type="checkbox"
          id="termsCheckbox"
          label="I accept the Terms and Conditions"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between border-0">
        <Button
          variant="outline-secondary"
          className="px-4 py-2"
          onClick={onDecline}
        >
          Decline
        </Button>
        <Button
          variant="primary"
          className="px-4 py-2"
          onClick={onAccept}
          disabled={!checked}
        >
          Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TermsModal;